'use client';

import { XMarkIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { trackFathomEvent } from '@/lib/fathom/trackFathomEvent';
import { LEGACY_FATHOM_EVENTS } from '@/lib/fathom/fathom-events';

type BannerProps = {
  handleCloseBanner: () => void;
  isBannerOpen: boolean;
};

function Banner({ handleCloseBanner, isBannerOpen }: BannerProps) {
  const trackMarketingBannerClick = trackFathomEvent(LEGACY_FATHOM_EVENTS.MARKETING_BANNER_LINK_CLICK);

  // check with growth marketing team before we edit these.
  const promoAttributes = {
    'data-promo': true,
    'data-promo-offer': 'dpe-summit_050125',
    'data-promo-location': 'gradle.com',
    'data-promo-type': 'link',
  };

  const url =
    'https://dpe.org/dpe-summit?utm_campaign=dpe-summit-2025&utm_medium=website&utm_source=gradle-com&utm_content=site-banner-summit-050125';

  return (
    <div
      className={clsx(
        'bg-custom-gradient overflow-hidden transition-all duration-500',
        isBannerOpen ? 'max-h-[--navbarBannerMobileHeight]' : 'max-h-0',
      )}
      data-testid="announcement-banner"
      data-banner-open={isBannerOpen}
    >
      <div className="max-w-section flex h-[--navbarBannerMobileHeight] items-center justify-center px-3 py-[0.625rem] text-center text-body-md text-white md:h-[--navbarBannerHeight]">
        <p className="w-full leading-[18px]">
          Join the only event dedicated to Developer Productivity Engineering.{' '}
          <a href={url} className="mega-menu-link underline" {...promoAttributes} onClick={trackMarketingBannerClick}>
            Learn more
          </a>
        </p>
        <button
          onClick={handleCloseBanner}
          className="cursor-pointer rounded-full p-1 transition-colors hover:bg-gradle-blue"
        >
          <XMarkIcon className="size-5 transition-transform md:size-4" />
        </button>
      </div>
    </div>
  );
}

export default Banner;
